var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ShiftOpportunityType, UnavailableReasons } from '@amzn/atoz-shiftapp-types';
export var getFindShiftsOpportunitiesVariables = function (dynamicVariables) {
    return __assign({ filter: {
            includeIneligible: true,
            unavailableReasonsToInclude: [
                UnavailableReasons.AssociateAccepted,
                UnavailableReasons.ShiftOpportunityCapacityMet,
                UnavailableReasons.ShiftOpportunityExpired
            ]
        }, opportunityTypes: {
            types: [
                ShiftOpportunityType.Drop,
                ShiftOpportunityType.VoluntaryTimeOff,
                ShiftOpportunityType.Add,
                ShiftOpportunityType.VoluntaryExtraTime
            ]
        } }, dynamicVariables);
};
